<!-- Detalle Productos Desembolso -->
<div *ngIf="productoDesembolso">
  <!-- 1 -->
  <div class="grid">
    <div class="lg:col-6 col-12 col-nopad">
      <div class="grid">
        <div class="col-12">
          <h2 class="">{{ 'PRODUCTO.LBL_RANGOMONTOAPROBADO' | translate }}</h2>
        </div>
        <div class="col-6">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MINIMA' | translate }}: </strong></label>
          <label class="">{{ productoDesembolso.rangoMontoAprobadoMinimo| numero:2 }}</label>
        </div>
        <div class="col-6">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MAXIMA' | translate }}: </strong></label>
          <label class="">{{ productoDesembolso.rangoMontoAprobadoMaximo| numero:2 }}</label>
        </div>
      </div>
    </div>
    <div class="lg:col-6 col-12 col-nopad">
      <div class="grid">
        <div class="col-12">
          <h2 class="">{{ 'PRODUCTO.LBL_RANGOPLAZOAPROBADO' | translate }}</h2>
        </div>
        <div class="col-6">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MINDIA' | translate }}: </strong></label>
          <label class="">{{ productoDesembolso.rangoPlazoAprobadoMinimo| numero:2 }}</label>
        </div>
        <div class="col-6">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MAXDIA' | translate }}: </strong></label>
          <label class="">{{ productoDesembolso.rangoPlazoAprobadoMaximo| numero:2 }}</label>
        </div>
      </div>
    </div>
  </div>
  <!-- 2 -->
  <div class="grid">
    <div class="col-12">
      <h2 class="">{{ 'PRODUCTO.LBL_RANGOTASAPRODUCTO' | translate }}</h2>
    </div>
    <div class="lg:col-3 col-6">
      <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MINIMA' | translate }}: </strong></label>
      <label class="">{{ productoDesembolso.rangoTasaProductoMinimo| numero:2 }}</label>
    </div>
    <div class="lg:col-3 col-6">
      <label class="control-label"><strong>{{ 'PRODUCTO.LBL_ORDINARIA' | translate }}: </strong></label>
      <label class="">{{ productoDesembolso.rangoTasaProductoOrdinario| numero:2 }}</label>
    </div>
    <div class="lg:col-6 col-12">
      <label class="control-label"><strong>{{ 'PRODUCTO.LBL_LIMITEDIADESEMBOLSO' | translate }}: </strong></label>
      <label class="">{{ productoDesembolso.limiteDiaDesembolso| numero:2 }}</label>
    </div>
  </div>
  <!-- 3 -->
  <div class="grid">
    <div class="lg:col-6 col-12 col-nopad">
      <div class="grid">
        <div class="col-12">
          <h2 class="">{{ 'PRODUCTO.LBL_CANTDESEMPARCIALES' | translate }}</h2>
        </div>
        <div class="col-6">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MINIMA' | translate }}: </strong></label>
          <label class="">{{ productoDesembolso.minimoDiaCantidadDesembolsoParcial| numero:2 }}</label>
        </div>
        <div class="col-6">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MAXIMA' | translate }}: </strong></label>
          <label class="">{{ productoDesembolso.maximoDiaCantidadDesembolsoParcial| numero:2 }}</label>
        </div>
      </div>
    </div>
    <div class="lg:col-6 col-12 col-nopad">
      <div class="grid">
        <div class="col-12">
          <h2 class="">{{ 'PRODUCTO.LBL_RANGOAMPLIARPLAZO' | translate }}</h2>
        </div>
        <div class="col-6">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MINDIA' | translate }}: </strong></label>
          <label class="">{{ productoDesembolso.rangoAmpliarPlazoMinimoDia| numero:2 }}</label>
        </div>
        <div class="col-6">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MAXDIA' | translate }}: </strong></label>
          <label class="">{{ productoDesembolso.rangoAmpliarPlazoMaximoDia| numero:2 }}</label>
        </div>
      </div>
    </div>
  </div>
  <!-- 4 -->
  <div class="grid">
    <div class="lg:col-3 col-6">
      <label class="control-label"><strong>{{ 'PRODUCTO.LBL_VECESPLAZOAMPLIAR' | translate }}: </strong></label>
      <label class="">{{ productoDesembolso.ampliarPlazo| numero:2 }}</label>
    </div>
    <div class="lg:col-3 col-6">
      <label class="control-label"><strong>{{ 'PRODUCTO.LBL_DIASMAXMORACLIENTE' | translate }}: </strong></label>
      <label class="">{{ productoDesembolso.diaMaximoMoraCliente| numero:2 }}</label>
    </div>
    <div class="lg:col-6 col-12">
      <label class="control-label"><strong>{{ 'PRODUCTO.LBL_DIASMAXMORAPRODUCTO' | translate }}: </strong></label>
      <label class="">{{ productoDesembolso.diaMaximoMoraProducto| numero:2 }}</label>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}" (click)="regresar()" pButton></button>
    </div>
  </div>
</div>
